/**
 * AndVFunnel - 漏斗图组件
 * 基于 Ant Design Charts Funnel
 */
import React from 'react';
import { Funnel } from '@ant-design/plots';
import { withBaseChart } from '../base/BaseChart';
import type { AndVFunnelProps } from '../base/types';

const DEFAULT_FUNNEL_DATA = [
  { stage: '申购申请', value: 520 },
  { stage: '科室论证', value: 380 },
  { stage: '采购立项', value: 240 },
  { stage: '招标采购', value: 150 },
  { stage: '验收入库', value: 98 },
];

const FunnelWithBase = withBaseChart<AndVFunnelProps>(Funnel, {
  chartType: 'AndVFunnel',
  defaultHeight: 300,
  defaultData: DEFAULT_FUNNEL_DATA,
});

export const AndVFunnel: React.FC<AndVFunnelProps> = (props) => {
  const {
    xField = 'stage',
    yField = 'value',
    compareField,
    seriesField,
    shapeField,
    isTransposed = true,
    ...baseProps
  } = props;

  const chartProps: Record<string, unknown> = {
    ...baseProps,
    xField,
    yField,
    isTransposed,
  };

  if (compareField) chartProps.compareField = compareField;
  if (seriesField) chartProps.seriesField = seriesField;
  if (shapeField) chartProps.shapeField = shapeField;

  return <FunnelWithBase {...chartProps} />;
};

export type { AndVFunnelProps };
export default AndVFunnel;
